<template>
    <div class="classBox" ref="recommendContainer">
        <div class="spinner-border text-primary" role="status" v-if="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="mainClassBox" v-show="!isLoading">
            <div class="periodJob"><img :src="periodJobImg" alt=""></div>
            <div id="mainClassSlider" class="splide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide" v-for="(item, index) in periodData" :key="index">
                            <div class="mobilePeriodJob">
                                <img :src="item.mobilePeriodJob" alt="">
                            </div>
                            <div class="period">
                                <span>{{ item.periodName }}</span>
                                <img :src="item.background" alt="">
                            </div>
                            <div class="mainClass">
                                <span class="text-center" v-html="item.mainClassText"></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="subClassBox" v-show="!isLoading">
            <div id="subClassSlider" class="splide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide" v-for="(item, index) in services" :key="index">
                            <div :id="item.id" class="splide">
                                <div class="splide__track">
                                    <ul class="splide__list">
                                        <li class="splide__slide" v-for="subItem in item.data" :key="subItem.id">
                                            <div class="subClassItem">
                                                <div class="subClassPic">
                                                    <img :src="subItem.Pic" alt="">
                                                </div>
                                                <div class="subClassText">
                                                    <div class="subClassName">{{ subItem.name }}</div>
                                                    <div class="subClassIntro" v-html="subItem.intro"></div>
                                                    <a :href="`search/clinic?serviceClassMetaId=${subItem.classMetaId}`">
                                                        <div class="checkBtn">查看更多</div>
                                                    </a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

export default {
    name: 'PrepageMainServices',
    components: {
    },
    props: {
        show: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: true,
        },
        url: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '/api/getPrepageMainServices',
        },
    },
    data() {
        return {
            currentShow: false,
            isLoading: true,
            services: [
                { id: 'rehabilitationSplider', data: [], name: '復健科骨科' },
                { id: 'physiotherapySplider', data: [], name: '物理治療' },
                { id: 'trainingSplider', data: [], name: '運動訓練' },
            ],
            periodJobImg: 'img/pic/clinic/periodJob.svg',
            periodData: [
                {
                    periodName: '急性期',
                    mobilePeriodJob: 'img/pic/clinic/mobilePeriodJob1.svg',
                    background: 'img/pic/clinic/periodBackground1.png',
                    mainClassText: '復健科/骨科/疼痛科<br>(建置中)',
                },
                {
                    periodName: '恢復期',
                    mobilePeriodJob: 'img/pic/clinic/mobilePeriodJob2.svg',
                    background: 'img/pic/clinic/periodBackground2.png',
                    mainClassText: '物理治療/整復',
                },
                {
                    periodName: '健康期',
                    mobilePeriodJob: 'img/pic/clinic/mobilePeriodJob3.svg',
                    background: 'img/pic/clinic/periodBackground3.png',
                    mainClassText: '運動訓練/肌肉放鬆<br>(建置中)',
                },
            ],
        };
    },
    beforeMount() {
        this.currentShow = !!(this.show);
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 10% 的範圍時觸發
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.currentShow) {
                        this.getResult();
                        observer.unobserve(this.$refs.recommendContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);
            if (this.$refs.recommendContainer) {
                observer.observe(this.$refs.recommendContainer);
            }
        },
        initSplide() {
            // 初始化 Splide 的通用設定
            const createSplide = (selector, options, syncWith = null) => {
                const splideInstance = new Splide(selector, options);
                if (syncWith) {
                    splideInstance.sync(syncWith);
                }
                splideInstance.mount();
                return splideInstance;
            };

            // 主 Slider
            const mainClass = createSplide('#mainClassSlider', {
                pagination: false,
                arrows: false,
                drag: false,
                isNavigation: true,
                focus: 'center',
                perPage: 3,
                start: 1,
                breakpoints: {
                    480: {
                        drag: true,
                        perPage: 2,
                    },
                },
            });

            // 子 Slider
            createSplide('#subClassSlider', {
                type: 'fade',
                pagination: false,
                arrows: false,
                drag: false,
                start: 1,
            }, mainClass);

            // 每個服務的 Slider
            this.services.forEach((service) => {
                createSplide(`#${service.id}`, {
                    pagination: false,
                    arrows: true,
                    perPage: 4,
                    gap: 15,
                    focus: 0,
                    breakpoints: {
                        480: { perPage: 1 },
                        768: { perPage: 2 },
                        1024: { perPage: 3 },
                    },
                });
            });
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}`);
                const { rehabilitation, physiotherapy, exerciseTraining } = response.data;
                this.services[0].data = rehabilitation;
                this.services[1].data = physiotherapy;
                this.services[2].data = exerciseTraining;
                this.isLoading = false;
                if (this.services.some((service) => service.data.length > 0)) {
                    this.$nextTick(() => this.initSplide());
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
    },
};
</script>
<style scoped lang="scss">
$maincolor: #72ca4a;
.spinner-border {
    margin: 0 50%;
}
.text-center {
    text-align: center;
}
</style>
